import { render, staticRenderFns } from "./school-editor.vue?vue&type=template&id=b96ff3aa&"
import script from "./school-editor.vue?vue&type=script&lang=js&"
export * from "./school-editor.vue?vue&type=script&lang=js&"
import style0 from "./school-editor.vue?vue&type=style&index=0&id=b96ff3aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports